<template>
    <div>
        <div class="information_title">价格规则</div>
        <!-- 价格规格表单 -->
        <div class="form_box">
            <el-form
                ref="fromOne"
                rl-foref="form"
                :model="from"
                label-width="200px"
                label-position="left"
                :rules="rulesFrom"
            >
                <el-form-item label="是否设置节假日价格：">
                    <div class="radio_yes" @click="from.houseFavour.iSettingFestival = 1">
                        <div
                            class="radio_yes_left_s"
                            v-if="from.houseFavour.iSettingFestival == 1"
                        >
                            <div class="radio_box"></div>
                        </div>
                        <div class="radio_yes_left" v-else></div>
                        <div class="radio_yes_right">是</div>
                    </div>
                    <div class="radio_yes" @click="from.houseFavour.iSettingFestival = 0">
                        <div
                            class="radio_yes_left_s"
                            v-if="from.houseFavour.iSettingFestival == 0"
                        >
                            <div class="radio_box"></div>
                        </div>
                        <div class="radio_yes_left" v-else></div>
                        <div class="radio_yes_right">否</div>
                    </div>
                    <!-- <div class="radio_no" @click="ischeck = 2">
                      <div class="radio_no_left_s" v-if="ischeck == 2">
                        <div class="radio_box"></div>
                      </div>
                      <div class="radio_no_left" v-else></div>
                      <div class="radio_no_right">否</div>
                    </div> -->
                    <div class="radio_text">周五、周六及法定假日、情人节、圣诞节等</div>
                </el-form-item>
                <!-------------------------------分割线 ------------------------------------->
                <el-form-item label="售卖价格：" required>
                    <div class="form_item">
                        <div class="form_item_title">
                            周日-周四价格
                        </div>
                        <div
                            class="form_item_title"
                            v-if="from.houseFavour.iSettingFestival == 1"
                        >
                            周末价格
                        </div>
                        <div
                            class="form_item_title"
                            v-if="from.houseFavour.iSettingFestival == 1"
                        >
                            节假日价格
                        </div>
                    </div>
                    <el-col :span="4">
                        <el-form-item
                            prop="houseFavour.mDailyPrice"
                        >
                            <el-input
                                oninput="value=value.replace(/[^\d.]/g,'')"
                                v-model="from.houseFavour.mDailyPrice"
                                placeholder="请输入内容"
                            ></el-input
                            >
                            <span>/晚</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" v-if="from.houseFavour.iSettingFestival == 1">
                        <el-form-item
                            prop="houseFavour.mWeekEndPrice"

                        >
                            <el-input
                                oninput="value=value.replace(/[^\d.]/g,'')"
                                v-model="from.houseFavour.mWeekEndPrice"
                                placeholder="请输入内容"
                            ></el-input
                            >
                            <span>/晚</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" v-if="from.houseFavour.iSettingFestival == 1">
                        <el-form-item
                            prop="houseFavour.mFestivePrice"

                        >
                            <el-input
                                oninput="value=value.replace(/[^\d.]/g,'')"
                                v-model="from.houseFavour.mFestivePrice"
                                placeholder="请输入内容"
                            ></el-input
                            >
                            <span>/晚</span>
                        </el-form-item>
                    </el-col>
                    <!-- <el-input
                      v-model="from.houseFavour.mDailyPrice"
                      placeholder="请输入内容"
                    ></el-input
                    ><span>/晚</span>
                    <el-input
                      v-model="from.houseFavour.mWeekEndPrice"
                      placeholder="请输入内容"
                      v-if="from.houseFavour.iSettingFestival == 1"
                    ></el-input
                    ><span v-if="from.houseFavour.iSettingFestival == 1">/晚</span>
                    <el-input
                      v-model="from.houseFavour.mFestivePrice"
                      placeholder="请输入内容"
                      v-if="from.houseFavour.iSettingFestival == 1"
                    ></el-input
                    ><span v-if="from.houseFavour.iSettingFestival == 1">/晚</span> -->
                </el-form-item>
                <!-------------------------------分割线 ------------------------------------->
                <el-form-item label="押金：">
                    <!-- prop="houseFavour.mDepositMoney"
                    :rules="[
                      { required: true, message: '押金不能为空', trigger: 'blur' }
                    ]" -->
                    <div class="iDepositRule">
                        <div class="radio_no" @click="from.houseFavour.iDepositRule = 0">
                            <div
                                class="radio_no_left_s"
                                v-if="from.houseFavour.iDepositRule == 0"
                            >
                                <div class="radio_box"></div>
                            </div>
                            <div class="radio_no_left" v-else></div>
                            <div class="radio_no_right">不收取押金</div>
                        </div>
                        <div class="radio_no" @click="from.houseFavour.iDepositRule = 1">
                            <div
                                class="radio_no_left_s"
                                v-if="from.houseFavour.iDepositRule == 1"
                            >
                                <div class="radio_box"></div>
                            </div>
                            <div class="radio_no_left" v-else></div>
                            <div class="radio_no_right">平台代收押金</div>
                        </div>
                        <div class="radio_no" @click="from.houseFavour.iDepositRule = 2">
                            <div
                                class="radio_no_left_s"
                                v-if="from.houseFavour.iDepositRule == 2"
                            >
                                <div class="radio_box"></div>
                            </div>
                            <div class="radio_no_left" v-else></div>
                            <div class="radio_no_right">房东线下收取押金</div>
                        </div>
                    </div>
                    <div
                        class="iDepositRule_input"
                        v-if="
              from.houseFavour.iDepositRule == 2 ||
                from.houseFavour.iDepositRule == 1
            "
                    >
                        <el-input
                            oninput="value=value.replace(/[^\d.]/g,'')"
                            v-model="from.houseFavour.mDepositMoney"
                            placeholder="请输入内容"
                        ></el-input
                        >
                        元
                    </div>
                </el-form-item>
                <!-------------------------------分割线 ------------------------------------->
                <el-form-item
                    label="可住人数："
                    prop="houseFavour.iResidentNum"
                >
                    <el-input
                        oninput="value=value.replace(/[^\d.]/g,'')"
                        v-model="from.houseFavour.iResidentNum"
                        type="number"
                        :min="1"
                        placeholder="请输入内容"
                    ></el-input
                    >
                    人
                    <span class="input_text">不可超过所有床型可住人数上限</span>
                </el-form-item>
                <!------------------------------ 分割线 ------------------------------------>
                <el-form-item label="是否允许加客：">
                    <div class="radio_yes" @click="from.houseFavour.iCusPlus = 0">
                        <div class="radio_yes_left_s" v-if="from.houseFavour.iCusPlus == 0">
                            <div class="radio_box"></div>
                        </div>
                        <div class="radio_yes_left" v-else></div>
                        <div class="radio_yes_right">否</div>
                    </div>
                    <div class="radio_yes" @click="from.houseFavour.iCusPlus = 1">
                        <div class="radio_yes_left_s" v-if="from.houseFavour.iCusPlus == 1">
                            <div class="radio_box"></div>
                        </div>
                        <div class="radio_yes_left" v-else></div>
                        <div class="radio_yes_right">是</div>
                    </div>
                </el-form-item>
                <!------------------------------ 分割线 ------------------------------------>
                <el-form-item
                    label="最多可加人数："
                    v-if="from.houseFavour.iCusPlus == 1"
                >
                    <el-input
                        v-model="from.houseFavour.iCusPlusNum"
                        placeholder="请输入内容"
                    ></el-input
                    >
                    人
                    <span class="input_text">不可超过所有床型可住人数上限</span>
                    加客费：
                    <el-input
                        class=""
                        v-model="from.houseFavour.mCusPlusMoney"
                        placeholder="请输入内容"
                    ></el-input
                    >
                    人/晚
                </el-form-item>
                <!----------------------------- 分割线 ------------------------------------>
                <el-form-item label="其它额外费用：">
                    <el-input
                        class="input_title"
                        type="textarea"
                        maxlength="2000 "
                        resize="none"
                        show-word-limit
                        placeholder="对水费、电费、燃气费等其他费用有其他要求，请进行描述。（选填）"
                        v-model="from.houseFavour.mOtherMoney"
                    >
                    </el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="information_title">优惠活动</div>
        <!-- 优惠活动 -->
        <div class="form_box">
            <el-form
                ref="fromTow"
                rl-foref="form"
                :model="from"
                label-width="200px"
                label-position="left"
            >
                <el-form-item label="开启新房促销：">
                    <div class="radio" @click="from.houseFavour.iNewSale = 1">
                        <div class="radio_left_" v-if="from.houseFavour.iNewSale == 1">
                            <div class="ischeck"></div>
                        </div>
                        <div class="radio_left" v-else></div>
                        <div class="radio_right">
                            <div class="radio_right_top">
                                参与新房促销
                            </div>
                            <div class="radio_right_bottom">
                                前3单入住的房客将享受8折促销。新房促销有助于提升您在众多房源中的竞争力，并增加房源的曝光度
                            </div>
                        </div>
                    </div>
                    <div class="radio " @click="from.houseFavour.iNewSale = 0">
                        <div class="radio_left_" v-if="from.houseFavour.iNewSale == 0">
                            <div class="ischeck"></div>
                        </div>
                        <div class="radio_left" v-else></div>
                        <div class="radio_right">
                            <div class="radio_right_top">
                                不参与新房促销
                            </div>
                            <div class="radio_right_bottom">
                                较其他新房源可能不具备有利的价格优势及足够的吸引力
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <!-------------------------------分割线 ------------------------------------->
                <el-form-item label="优惠折扣：">
                    <el-input
                        v-model="from.houseFavour.mNewCount"
                        placeholder="请输入内容"
                        disabled
                    ></el-input
                    >
                    折
                </el-form-item>
                <!-------------------------------分割线 ------------------------------------->
                <div class="bedMessage">
                    <el-checkbox
                        v-model="from.houseFavour.iLinkSale"
                        :checked="from.houseFavour.iLinkSale == 1 ? true : false"
                        true-label="1"
                        false-label="0"
                    >设置连住优惠：
                    </el-checkbox
                    >
                    <div class="form_item">
                        <div class="form_item_title_s">
                            为连住的房客提供优惠，获更多省心长单
                        </div>
                    </div>
                </div>
                <div v-if="from.houseFavour.iLinkSale == 1">
                    <el-form-item
                        v-for="(item, index) in from.houseRuleLink"
                        :key="index"
                        required
                    >
                        <div class="acreage">
                            <el-col :span="7">
                                <el-form-item
                                    :prop="'houseRuleLink.' + index + '.iLinkDays'"
                                    :rules="[
                    {
                      required: true,
                      message: '连住天数不能为空',
                      trigger: 'change'
                    }
                  ]"
                                >
                                    连续入住满
                                    <!-- <el-cascader
                                      :options="optionsDays"
                                      v-model="item.iLinkDays"
                                      clearable
                                      placeholder="请选择"
                                    ></el-cascader> -->
                                    <el-select v-model="item.iLinkDays" placeholder="请选择">
                                        <el-option
                                            v-for="item in optionsDays"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                    的房客享受
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item
                                    :prop="'houseRuleLink.' + index + '.iLinkCount'"
                                    :rules="[
                    {
                      required: true,
                      message: '折扣不能为空',
                      trigger: 'change'
                    }
                  ]"
                                >
                                    <el-select v-model="item.iLinkCount" placeholder="请选择">
                                        <el-option
                                            v-for="item in optionsCount"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select
                                    >
                                    折扣的房价
                                </el-form-item>
                            </el-col>

                            <el-button
                                v-if="index == 0"
                                icon="el-icon-plus"
                                @click="addDomain"
                                class="addDomain"
                            >继续添加
                            </el-button
                            >
                            <el-button
                                v-else
                                @click.prevent="removeDomain(item)"
                                icon="el-icon-delete"
                                class="removeDomain"
                            >删除
                            </el-button
                            >
                        </div>
                    </el-form-item>
                </div>

                <!-------------------------------分割线 ------------------------------------->
                <div class="bedMessageOther">
                    <el-checkbox
                        v-model="from.houseFavour.iNightSale"
                        :checked="from.houseFavour.iNightSale == 1 ? true : false"
                        true-label="1"
                        false-label="0"
                    >今夜特价：
                    </el-checkbox
                    >
                </div>
                <div class="iNightSale_text">当晚超时未卖出就打折，和空房说再见</div>
                <el-form-item v-if="from.houseFavour.iNightSale == 1">
                    <div class="select_box">
                        <el-form-item
                            :prop="'houseRuleNight.' + 0 + '.dNightStart'"
                            :rules="[
                {
                  required: true,
                  message: '时间不能为空',
                  trigger: 'change'
                }
              ]"
                        >
                            超过
                            <el-select
                                v-model="from.houseRuleNight[0].dNightStart"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in optionsNightStart"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item
                            :prop="'houseRuleNight.' + 0 + '.iNightCount'"
                            :rules="[
                {
                  required: true,
                  message: '折扣不能为空',
                  trigger: 'change'
                }
              ]"
                        >
                            未卖出，当日该房源将自动从8折开始将逐小时降价，最低降至
                            <el-select
                                v-model="from.houseRuleNight[0].iNightCount"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in optionsNightCount"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    折扣房价出售
                    <span class="input_text"
                    >根据平日价预计每小时降价1~4元，最低降至100元</span
                    >
                </el-form-item>
            </el-form>
        </div>
        <div class="information_title">预定规则</div>
        <!-- 预定规则 -->
        <div class="form_box">
            <el-form
                ref="fromThree"
                rl-foref="form"
                :model="from"
                :rules="rulesFrom"
                label-width="200px"
                label-position="left"
            >
                <el-form-item label="最少入住天数：" required>
                    <el-col :span="4">
                        <el-form-item
                            prop="houseFavour.iMiniDays"

                        >
                            <el-input
                                v-model="from.houseFavour.iMiniDays"
                                placeholder="请输入内容"
                            ></el-input
                            >
                            天
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item
                            prop="houseFavour.iMaxDays"
                            :rules="[
                {
                  required: true,
                  message: '入住天数不能为空',
                  trigger: 'blur'
                }
              ]"
                        >
              <span>最多入住天数：</span
              >
                            <el-input
                                v-model="from.houseFavour.iMaxDays"
                                placeholder="0为不设限"
                            ></el-input
                            >
                            天 （0为不设限）
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <!-------------------------------分割线 ------------------------------------->
                <el-form-item
                    label="当天预定时间："
                    prop="houseFavour.iScheduledTime"
                    :rules="[
            { required: true, message: '当天预定时间', trigger: 'change' }
          ]"
                >
                    <div class="form_item">
                        <div class="form_item_title">
                            客人可在几点前预订当天房源
                        </div>
                    </div>
                    <el-select
                        v-model="from.houseFavour.iScheduledTime"
                        placeholder="请选择"
                        class="none_margin"
                    >
                        <el-option
                            v-for="item in optionsNightStart"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-------------------------------分割线 ------------------------------------->
                <el-form-item label="入住时间：" required>
                    <div class="form_item">
                        <div class="form_item_title">
                            客人最早几点可以入住
                        </div>
                    </div>
                    <el-col :span="3">
                        <el-form-item
                            prop="houseFavour.iCheckStartTime"
                            :rules="[
                {
                  required: true,
                  message: '时间不能为空',
                  trigger: 'change'
                }
              ]"
                        >
                            <el-select
                                v-model="from.houseFavour.iCheckStartTime"
                                placeholder="请选择"
                                class="none_margin"
                            >
                                <el-option
                                    v-for="item in optionsNightStart"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col class="line" :span="1">至</el-col>
                    <el-col :span="3">
                        <el-form-item
                            prop="houseFavour.iCheckEndTime"
                            :rules="[
                {
                  required: true,
                  message: '时间不能为空',
                  trigger: 'change'
                }
              ]"
                        >
                            <el-select
                                v-model="from.houseFavour.iCheckEndTime"
                                placeholder="请选择"
                                class="none_margin"
                            >
                                <el-option
                                    v-for="item in optionsNightStart"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <!-------------------------------分割线 ------------------------------------->
                <el-form-item
                    label="退房时间："
                    prop="houseFavour.iCheckOutTime"
                    :rules="[{ required: true, message: '退房时间', trigger: 'change' }]"
                >
                    <div class="form_item">
                        <div class="form_item_title">
                            客人最晚退房时间
                        </div>
                    </div>
                    <el-select
                        v-model="from.houseFavour.iCheckOutTime"
                        placeholder="请选择"
                        class="none_margin"
                    >
                        <el-option
                            v-for="item in optionsNightStart"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <!------------------------------ 分割线 ------------------------------------>
                <el-form-item label="房客退订规则：">
                    <div
                        class="radio"
                        style="width:600px"
                        @click="from.houseFavour.iCheckRule = 0"
                    >
                        <div class="radio_left_" v-if="from.houseFavour.iCheckRule == 0">
                            <div class="ischeck"></div>
                        </div>
                        <div class="radio_left" v-else></div>
                        <div class="radio_right">
                            <div class="radio_right_top">
                                宽松
                            </div>
                            <div class="radio_right_bottom">
                                入住前一天12:00前退订，可获100%退款。之后退订不退款
                            </div>
                        </div>
                    </div>
                    <div
                        class="radio "
                        style="width:600px"
                        @click="from.houseFavour.iCheckRule = 1"
                    >
                        <div class="radio_left_" v-if="from.houseFavour.iCheckRule == 1">
                            <div class="ischeck"></div>
                        </div>
                        <div class="radio_left" v-else></div>
                        <div class="radio_right">
                            <div class="radio_right_top">
                                适中
                            </div>
                            <div class="radio_right_bottom">
                                入住前五天12:00前退订，可获100%退款。之后退订不退款
                            </div>
                        </div>
                    </div>
                    <div
                        class="radio "
                        style="width:600px"
                        @click="from.houseFavour.iCheckRule = 2"
                    >
                        <div class="radio_left_" v-if="from.houseFavour.iCheckRule == 2">
                            <div class="ischeck"></div>
                        </div>
                        <div class="radio_left" v-else></div>
                        <div class="radio_right">
                            <div class="radio_right_top">
                                严格
                            </div>
                            <div class="radio_right_bottom">
                                入住前七天12:00前退订，可获100%退款。之后退订不退款
                            </div>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div class="information_title">上传房源资质</div>
        <!-- 上传房源资质 -->
        <!-- <div class="form_box"> -->
        <div class="qualification">
            <div class="qualification_left">特别提示：</div>
            <div class="qualification_right">
                房屋资质验证资料仅用于验证房屋的真实性与合法性，不会用于任何平台的展示、宣传，请上传真实有效的证明材料，
                <span>具备的材料文件请全部上传。</span>
            </div>
        </div>
        <div class="qualification">
            <div class="qualification_left">证件类型</div>
        </div>
        <div class="qualification_checkbox_list">
            <!-------- 分割线 --------->
            <div class="checkbox_Box" @click="from.houseFavour.vDocumentType = 0">
                <div class="qualification_checkbox">
                    <div
                        class="qualification_checkbox_true"
                        v-if="from.houseFavour.vDocumentType == 0"
                    >
                        <div class="checkbox_true"></div>
                    </div>
                    <div class="qualification_checkbox_false" v-else></div>
                </div>
                <div class="qualification_text">
                    营业执照
                </div>
            </div>
            <!-------- 分割线 --------->
            <div class="checkbox_Box" @click="from.houseFavour.vDocumentType = 1">
                <div class="qualification_checkbox">
                    <div
                        class="qualification_checkbox_true"
                        v-if="from.houseFavour.vDocumentType == 1"
                    >
                        <div class="checkbox_true"></div>
                    </div>
                    <div class="qualification_checkbox_false" v-else></div>
                </div>
                <div class="qualification_text">
                    房产证
                </div>
            </div>
            <!-------- 分割线 --------->
            <div class="checkbox_Box" @click="from.houseFavour.vDocumentType = 2">
                <div class="qualification_checkbox">
                    <div
                        class="qualification_checkbox_true"
                        v-if="from.houseFavour.vDocumentType == 2"
                    >
                        <div class="checkbox_true"></div>
                    </div>
                    <div class="qualification_checkbox_false" v-else></div>
                </div>
                <div class="qualification_text">
                    租赁合同
                </div>
            </div>
            <!-------- 分割线 --------->
            <div class="checkbox_Box" @click="from.houseFavour.vDocumentType = 3">
                <div class="qualification_checkbox">
                    <div
                        class="qualification_checkbox_true"
                        v-if="from.houseFavour.vDocumentType == 3"
                    >
                        <div class="checkbox_true"></div>
                    </div>
                    <div class="qualification_checkbox_false" v-else></div>
                </div>
                <div class="qualification_text">
                    其他证件
                </div>
            </div>
            <br/>
            <!-------- 分割线 --------->
            <div class="checkbox_Box" @click="from.houseFavour.vDocumentType = 4">
                <div class="qualification_checkbox">
                    <div
                        class="qualification_checkbox_true"
                        v-if="from.houseFavour.vDocumentType == 4"
                    >
                        <div class="checkbox_true"></div>
                    </div>
                    <div class="qualification_checkbox_false" v-else></div>
                </div>
                <div class="qualification_text">
                    特种行业许可证
                </div>
            </div>
            <!-------- 分割线 --------->
            <div class="checkbox_Box" @click="from.houseFavour.vDocumentType = 5">
                <div class="qualification_checkbox">
                    <div
                        class="qualification_checkbox_true"
                        v-if="from.houseFavour.vDocumentType == 5"
                    >
                        <div class="checkbox_true"></div>
                    </div>
                    <div class="qualification_checkbox_false" v-else></div>
                </div>
                <div class="qualification_text">
                    消防许可证
                </div>
            </div>
            <!-------- 分割线 --------->
            <div class="checkbox_Box" @click="from.houseFavour.vDocumentType = 6">
                <div class="qualification_checkbox">
                    <div
                        class="qualification_checkbox_true"
                        v-if="from.houseFavour.vDocumentType == 6"
                    >
                        <div class="checkbox_true"></div>
                    </div>
                    <div class="qualification_checkbox_false" v-else></div>
                </div>
                <div class="qualification_text">
                    卫生许可证
                </div>
            </div>
            <!-------- 分割线 --------->
            <div class="checkbox_Box" @click="from.houseFavour.vDocumentType = 7">
                <div class="qualification_checkbox">
                    <div
                        class="qualification_checkbox_true"
                        v-if="from.houseFavour.vDocumentType == 7"
                    >
                        <div class="checkbox_true"></div>
                    </div>
                    <div class="qualification_checkbox_false" v-else></div>
                </div>
                <div class="qualification_text">
                    租赁房屋治安责任保证书
                </div>
            </div>
        </div>
        <div class="qualification">
            上传证件原件照片或扫描件
            <img src="../../image/jingao.png" alt=""/><span>
        请上传一张材料图片</span
        >
        </div>
        <!-- 上传图片 -->
        <div class="qualification_photograph">
            <div class="qualification_title">
                请上传 .jpg 或 .png 格式，文件大小不得超过 5M
            </div>
            <div class="picture_upload">
                <!-- <div class="picture_box_title">可添加照片描述</div> -->
                <!-- 上传图片 action="http://192.168.2.120:8808/system/user/profile/wxCode"
                       action="https://test.youjiaminsu.cn:333/system/user/profile/wxCode" -->
                <el-upload
                    ref="my-upload"
                    :limit="1"
                    :headers="headers"
                    name="avatarfile"
                    action="/api/system/user/profile/wxCode"
                    list-type="picture-card"
                    :on-success="handleAvatarSuccess"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :file-list="handleAvatarSuccessList"
                >
                    <i class="el-icon-upload"></i>
                    <!-- <i class="el-icon-plus">添加照片</i> -->
                </el-upload>
                <el-dialog :visible.sync="dialogVisible_img">
                    <div class="img_title">浏览图片</div>
                    <img width="100%" :src="dialogImageUrl" alt=""/>
                </el-dialog>
            </div>
        </div>
        <div class="qualification_bottom"></div>
        <div class="qualification">
            <el-checkbox v-model="checkeds"></el-checkbox>
            我已阅读并同意
            <span>《房东规则》</span>、 <span>《房源上线标准》</span>
        </div>

        <!-- </div> -->
        <div class="next_Btn">
            <el-button
                class="affirm"
                @click="next_Btn('fromOne', 'fromTow', 'fromThree')"
            >确认发布
            </el-button
            >
            <el-button
                class="preview"
                @click="next_Btn_other('fromOne', 'fromTow', 'fromThree')"
            >预览并保存
            </el-button
            >
        </div>
    </div>
</template>

<script>
import {publishFiveAjax, hourseInfo, addModifyMT, pigOnlineHousing, pigAddModify} from "../../api/index";

export default {
    props: ["isStatus", "roomId"],
    data() {
        let validatorPrice = (rule, value, callback) => {
            console.log(value)
            if (value === '' || value == 0) {
                callback(new Error('请输入正确的价格'));
            } else {

                callback();
            }
        };
        let validatorNum = (rule, value, callback) => {
            console.log(value)
            if (value === '' || value == 0) {
                callback(new Error('数量不能为0或者空'));
            } else {

                callback();
            }
        };
        return {
            rulesFrom: {

                'houseFavour.mDailyPrice': [
                    {required: true, message: '平日价格不能为空', trigger: 'blur'},
                    {validator: validatorPrice, trigger: 'blur'}
                ],
                'houseFavour.mWeekEndPrice': [
                    {required: true, message: '周末价格不能为空', trigger: 'blur'},
                    {validator: validatorPrice, trigger: 'blur'}
                ],
                'houseFavour.mFestivePrice': [
                    {required: true, message: '节日价格不能为空', trigger: 'blur'},
                    {validator: validatorPrice, trigger: 'blur'}
                ],
                'houseFavour.iResidentNum': [
                    {required: true, message: '可住人数不能为空', trigger: 'blur'},
                    {validator: validatorNum, trigger: 'blur'}
                ],
                'houseFavour.iMiniDays': [
                    {required: true, message: '最少入住天数不能为空', trigger: 'blur'},
                    {validator: validatorNum, trigger: 'blur'}
                ]


            },
            optionsNightCount: [
                {
                    value: "7.5",
                    label: "7.5折"
                },
                {
                    value: "7",
                    label: "7折"
                },
                {
                    value: "6.5",
                    label: "6.5折"
                },
                {
                    value: "6",
                    label: "6折"
                },
                {
                    value: "5.5",
                    label: "5.5折"
                },
                {
                    value: "5",
                    label: "5折"
                },
                {
                    value: "4.5",
                    label: "4.5折"
                },
                {
                    value: "4",
                    label: "4折"
                },
                {
                    value: "3.5",
                    label: "3.5折"
                },
                {
                    value: "3",
                    label: "3折"
                },
                {
                    value: "2.5",
                    label: "2.5折"
                },
                {
                    value: "2",
                    label: "2折"
                },
                {
                    value: "1.5",
                    label: "1.5折"
                },
                {
                    value: "1",
                    label: "1折"
                }
            ],
            optionsCount: [
                {
                    value: "9",
                    label: "9折"
                },
                {
                    value: "8.5",
                    label: "8.5折"
                },
                {
                    value: "8",
                    label: "8折"
                },
                {
                    value: "7.5",
                    label: "7.5折"
                },
                {
                    value: "7",
                    label: "7折"
                },
                {
                    value: "6.5",
                    label: "6.5折"
                },
                {
                    value: "6",
                    label: "6折"
                },
                {
                    value: "5.5",
                    label: "5.5折"
                },
                {
                    value: "5",
                    label: "5折"
                },
                {
                    value: "4.5",
                    label: "4.5折"
                },
                {
                    value: "4",
                    label: "4折"
                },
                {
                    value: "3.5",
                    label: "3.5折"
                },
                {
                    value: "3",
                    label: "3折"
                },
                {
                    value: "2.5",
                    label: "2.5折"
                },
                {
                    value: "2",
                    label: "2折"
                },
                {
                    value: "1.5",
                    label: "1.5折"
                },
                {
                    value: "1",
                    label: "1折"
                }
            ],
            optionsDays: [
                {
                    value: "1",
                    label: "1天"
                },
                {
                    value: "2",
                    label: "2天"
                },
                {
                    value: "3",
                    label: "3天"
                },
                {
                    value: "4",
                    label: "4天"
                },
                {
                    value: "5",
                    label: "5天"
                },
                {
                    value: "6",
                    label: "6天"
                },
                {
                    value: "7",
                    label: "7天"
                },
                {
                    value: "8",
                    label: "8天"
                },
                {
                    value: "9",
                    label: "9天"
                },
                {
                    value: "10",
                    label: "10天"
                },
                {
                    value: "11",
                    label: "11天"
                },
                {
                    value: "12",
                    label: "12天"
                },
                {
                    value: "13",
                    label: "13天"
                },
                {
                    value: "14",
                    label: "14天"
                },
                {
                    value: "15",
                    label: "15天"
                },
                {
                    value: "16",
                    label: "16天"
                },
                {
                    value: "17",
                    label: "17天"
                },
                {
                    value: "18",
                    label: "18天"
                },
                {
                    value: "19",
                    label: "19天"
                },
                {
                    value: "20",
                    label: "20天"
                },
                {
                    value: "21",
                    label: "21天"
                },
                {
                    value: "22",
                    label: "22天"
                },
                {
                    value: "23",
                    label: "23天"
                },
                {
                    value: "24",
                    label: "24天"
                },
                {
                    value: "25",
                    label: "25天"
                },
                {
                    value: "26",
                    label: "26天"
                },
                {
                    value: "27",
                    label: "27天"
                },
                {
                    value: "28",
                    label: "28天"
                },
                {
                    value: "29",
                    label: "29天"
                },
                {
                    value: "30",
                    label: "30天"
                }
            ],
            optionsList: [
                {
                    value: "1",
                    label: "1"
                },
                {
                    value: "2",
                    label: "2"
                },
                {
                    value: "3",
                    label: "3"
                },
                {
                    value: "4",
                    label: "4"
                },
                {
                    value: "5",
                    label: "5"
                },
                {
                    value: "6",
                    label: "6"
                },
                {
                    value: "7",
                    label: "7"
                },
                {
                    value: "8",
                    label: "8"
                },
                {
                    value: "9",
                    label: "9"
                },
                {
                    value: "10",
                    label: "10"
                },
                {
                    value: "11",
                    label: "11"
                },
                {
                    value: "12",
                    label: "12"
                },
                {
                    value: "13",
                    label: "13"
                },
                {
                    value: "14",
                    label: "14"
                },
                {
                    value: "15",
                    label: "15"
                },
                {
                    value: "16",
                    label: "16"
                },
                {
                    value: "17",
                    label: "17"
                },
                {
                    value: "18",
                    label: "18"
                },
                {
                    value: "19",
                    label: "19"
                },
                {
                    value: "20",
                    label: "20"
                },
                {
                    value: "21",
                    label: "21"
                },
                {
                    value: "22",
                    label: "22"
                },
                {
                    value: "23",
                    label: "23"
                },
                {
                    value: "24",
                    label: "24"
                },
                {
                    value: "25",
                    label: "25"
                },
                {
                    value: "26",
                    label: "26"
                },
                {
                    value: "27",
                    label: "27"
                },
                {
                    value: "28",
                    label: "28"
                },
                {
                    value: "29",
                    label: "29"
                },
                {
                    value: "30",
                    label: "30"
                },
                {
                    value: "31",
                    label: "31"
                },
                {
                    value: "32",
                    label: "32"
                },
                {
                    value: "33",
                    label: "33"
                },
                {
                    value: "34",
                    label: "34"
                },
                {
                    value: "35",
                    label: "35"
                },
                {
                    value: "36",
                    label: "36"
                },
                {
                    value: "37",
                    label: "37"
                },
                {
                    value: "38",
                    label: "38"
                },
                {
                    value: "39",
                    label: "39"
                },
                {
                    value: "40",
                    label: "40"
                },
                {
                    value: "41",
                    label: "41"
                },
                {
                    value: "42",
                    label: "42"
                },
                {
                    value: "43",
                    label: "43"
                },
                {
                    value: "44",
                    label: "44"
                },
                {
                    value: "45",
                    label: "45"
                },
                {
                    value: "46",
                    label: "46"
                },
                {
                    value: "47",
                    label: "47"
                },
                {
                    value: "48",
                    label: "48"
                },
                {
                    value: "49",
                    label: "49"
                }
            ],
            optionsNightStart: [
                {
                    value: "1",
                    label: "1点"
                },
                {
                    value: "2",
                    label: "2点"
                },
                {
                    value: "3",
                    label: "3点"
                },
                {
                    value: "4",
                    label: "4点"
                },
                {
                    value: "5",
                    label: "5点"
                },
                {
                    value: "6",
                    label: "6点"
                },
                {
                    value: "7",
                    label: "7点"
                },
                {
                    value: "8",
                    label: "8点"
                },
                {
                    value: "9",
                    label: "9点"
                },
                {
                    value: "10",
                    label: "10点"
                },
                {
                    value: "11",
                    label: "11点"
                },
                {
                    value: "12",
                    label: "12点"
                },
                {
                    value: "13",
                    label: "13点"
                },
                {
                    value: "14",
                    label: "14点"
                },
                {
                    value: "15",
                    label: "15点"
                },
                {
                    value: "16",
                    label: "16点"
                },
                {
                    value: "17",
                    label: "17点"
                },
                {
                    value: "18",
                    label: "18点"
                },
                {
                    value: "19",
                    label: "19点"
                },
                {
                    value: "20",
                    label: "20点"
                },
                {
                    value: "21",
                    label: "21点"
                },
                {
                    value: "22",
                    label: "22点"
                },
                {
                    value: "23",
                    label: "23点"
                },
                {
                    value: "24",
                    label: "24点"
                }
            ],
            options: [
                {
                    value: "选项1",
                    label: "黄金糕"
                },
                {
                    value: "选项2",
                    label: "双皮奶"
                },
                {
                    value: "选项3",
                    label: "蚵仔煎"
                },
                {
                    value: "选项4",
                    label: "龙须面"
                },
                {
                    value: "选项5",
                    label: "北京烤鸭"
                }
            ],
            // 图片回显
            handleAvatarSuccessList: [],
            Status: "",
            houseId: window.sessionStorage.getItem("hourId") || "",
            IsGo: true,
            // active: 5,
            ischeck: 1,
            checkeds: false,
            from: {
                houseId: window.sessionStorage.getItem("hourId") || "",
                houseFavour: {
                    iLinkSale: 0,
                    mDepositMoney: "",
                    iSettingFestival: 0,
                    mDailyPrice: "",
                    mWeekEndPrice: "",
                    mFestivePrice: "",
                    iDepositRule: 0,
                    iResidentNum: 1,
                    iCusPlusNum: "",
                    iCusPlus: 1,
                    iNightSale: 0,
                    mCusPlusMoney: 0,
                    mOtherMoney: "",
                    iNewSale: 0,
                    mNewCount: "8",
                    iMiniDays: 1,
                    iMaxDays: "0",
                    iScheduledTime: "",
                    iCheckStartTime: "",
                    iCheckEndTime: "",
                    iCheckOutTime: "",
                    iCheckRule: 0,
                    vDocumentType: 0,
                    vDocumentPics: []
                },

                houseRuleLink: [
                    {
                        iLinkDays: "3",
                        iLinkCount: "9"
                    },
                    {
                        iLinkDays: "7",
                        iLinkCount: "8"
                    },
                    {
                        iLinkDays: "15",
                        iLinkCount: "7"
                    },
                    {
                        iLinkDays: "30",
                        iLinkCount: "6"
                    }
                ],
                houseRuleNight: [{dNightStart: "", iNightCount: ""}]
            },
            checked: true,
            dialogImageUrl: "",
            dialogVisible: false,
            dialogVisible_img: false
        };
    },
    created() {
        this.$nextTick(() => {
            document.querySelector(".el-main").scrollTop = 0;
        })
        this.Status = this.isStatus;
        if (this.Status == 1) this.hourseInfoAjax();
    },
    computed: {
        headers() {
            return {
                Authorization: "Bearer " + this.$store.state.user // 直接从本地获取token就行
            };
        }
    },
    methods: {
        // 修改时，获取数据
        async hourseInfoAjax() {
            const {data: res} = await hourseInfo(this.houseId);
            if (res.data.hourseInfo.houseFavour.iCheckOutTime == null) return;
            this.from.houseFavour.iSettingFestival =
                res.data.hourseInfo.houseFavour.iSettingFestival || "";
            this.from.houseFavour.mDailyPrice =
                res.data.hourseInfo.houseFavour.mDailyPrice || "";
            this.from.houseFavour.mWeekEndPrice =
                res.data.hourseInfo.houseFavour.mWeekEndPrice || "";
            this.from.houseFavour.iNewSale =
                res.data.hourseInfo.houseFavour.iNewSale || "";
            this.from.houseFavour.mFestivePrice =
                res.data.hourseInfo.houseFavour.mFestivePrice || "";
            this.from.houseFavour.iDepositRule =
                res.data.hourseInfo.houseFavour.iDepositRule || "";
            this.from.houseFavour.mDepositMoney =
                res.data.hourseInfo.houseFavour.mDepositMoney || "";
            this.from.houseFavour.iResidentNum =
                res.data.hourseInfo.houseFavour.iResidentNum || "";
            this.from.houseFavour.iCusPlus =
                res.data.hourseInfo.houseFavour.iCusPlus || "";
            this.from.houseFavour.iCusPlusNum =
                res.data.hourseInfo.houseFavour.iCusPlusNum || "";
            this.from.houseFavour.mOtherMoney =
                res.data.hourseInfo.houseFavour.mOtherMoney || "";
            this.from.houseFavour.mNewCount =
                res.data.hourseInfo.houseFavour.mNewCount || "";
            this.from.houseRuleLink = res.data.hourseInfo.houseRuleLink || "";
            this.from.houseFavour.iLinkSale =
                res.data.hourseInfo.houseFavour.iLinkSale.toString() || "";
            this.from.houseFavour.iNightSale =
                res.data.hourseInfo.houseFavour.iNightSale.toString() || "";
            this.from.houseFavour.mCusPlusMoney =
                res.data.hourseInfo.houseFavour.mCusPlusMoney || "";
            this.from.houseFavour.iMiniDays =
                res.data.hourseInfo.houseFavour.iMiniDays.toString() || "";
            this.from.houseFavour.iMaxDays =
                res.data.hourseInfo.houseFavour.iMaxDays.toString() || "";

            this.from.houseFavour.iScheduledTime =
                res.data.hourseInfo.houseFavour.iScheduledTime.toString() || "";
            this.from.houseFavour.iCheckStartTime =
                res.data.hourseInfo.houseFavour.iCheckStartTime.toString() || "";
            this.from.houseFavour.iCheckEndTime =
                res.data.hourseInfo.houseFavour.iCheckEndTime.toString() || "";
            this.from.houseFavour.iCheckOutTime =
                res.data.hourseInfo.houseFavour.iCheckOutTime.toString() || "";
            this.from.houseFavour.iCheckRule =
                res.data.hourseInfo.houseFavour.iCheckRule || "";
            this.from.houseFavour.vDocumentType =
                res.data.hourseInfo.houseFavour.vDocumentType || "";
            this.from.houseRuleNight[0].dNightStart =
                res.data.hourseInfo.houseRuleNight[0].dNightStart || "";
            this.from.houseRuleNight[0].iNightCount =
                res.data.hourseInfo.houseRuleNight[0].iNightCount || "";
            //房东id
            this.from.houseFavour.customerId = res.data.hourseInfo.customerId || ''
        },
        handleAvatarSuccess(response) {
            if (this.from.houseFavour.vDocumentPics.indexOf(response.msg) == -1) {
                this.from.houseFavour.vDocumentPics.push(response.msg);
            }
        },

        handleRemove(file, fileList) {
            var index = this.from.houseFavour.vDocumentPics.indexOf(
                file.response.msg
            );
            if (index !== -1) {
                this.from.houseFavour.vDocumentPics.splice(index, 1);
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible_img = true;
        },
        // 删除
        removeDomain(item) {
            var index = this.from.houseRuleLink.indexOf(item);
            if (index !== -1) {
                this.from.houseRuleLink.splice(index, 1);
            }
        },
        // 新增
        addDomain() {
            this.from.houseRuleLink.push({
                iLinkDays: "".toString(),
                iLinkCount: ""

                // key: Date.now()
            });
        },
        //上架第三方接口合集
        async tripartiteOnline(params) {
            let flag = {
                code: 0,
                msg: ''
            };
            //上线小猪
            //params.customerId
            const {data: res} = await pigOnlineHousing('?housingId=' + params.houseId + "&id=203");
            console.log('小猪回调', res.code)
            flag = {
                code: res.code,
                msg: res.msg
            }
            return flag;
        },
        next_Btn(fromOne, fromTow, fromThree) {
            this.$refs[fromOne].validate(valid => {
                if (valid) {
                    this.$refs[fromTow].validate(valid => {
                        if (valid) {
                            this.$refs[fromThree].validate(async valid => {
                                if (valid) {
                                    if (!this.checkeds) {
                                        return this.$message({
                                            type: "error",
                                            message: "是否认真阅读过房东规则、房源上线标准"
                                        });
                                    }

                                    if (!this.IsGo) return;
                                    this.IsGo = false;
                                    //设置默认周末和节日价格
                                    if (!this.from.houseFavour.mWeekEndPrice || !this.from.houseFavour.mFestivePrice) {
                                        this.from.houseFavour.mWeekEndPrice = this.from.houseFavour.mWeekEndPrice || this.from.houseFavour.mDailyPrice
                                        this.from.houseFavour.mFestivePrice = this.from.houseFavour.mFestivePrice || this.from.houseFavour.mDailyPrice
                                    }
                                    const {data: res} = await publishFiveAjax(this.from);
                                    console.log(res, "添加房源", "参数", this.from)
                                    if (res.code !== 200) {
                                        return this.$message({
                                            type: "error",
                                            message: res.msg
                                        });
                                    }
                                    console.log(this.roomId)
                                    //同步小猪房源信息
                                    if (this.houseId && this.from.houseFavour.customerId && this.roomId) {
                                        const {data: relut} = await pigAddModify({
                                            id: this.from.houseFavour.customerId,
                                            housingId: sessionStorage.getItem('hourId')
                                        });
                                        if (relut.code !== 200) {
                                            this.$message({
                                                type: "error",
                                                message: relut.msg
                                            });
                                        }
                                    }

                                    this.from = {
                                        checked: true,
                                        houseFavour: {
                                            mDepositMoney: "0",
                                            iSettingFestival: 0,
                                            mDailyPrice: "",
                                            mWeekEndPrice: "",
                                            mFestivePrice: "",
                                            iDepositRule: 0,
                                            iResidentNum: "",
                                            iCusPlusNum: "",
                                            iCusPlus: 1,
                                            mCusPlusMoney: "",
                                            mOtherMoney: "",
                                            iNewSale: 0,
                                            mNewCount: "8",
                                            iMiniDays: "",
                                            iMaxDays: "",
                                            iScheduledTime: "",
                                            iCheckStartTime: "",
                                            iCheckEndTime: "",
                                            iCheckOutTime: "",
                                            iCheckRule: 0,
                                            vDocumentType: 0,
                                            vDocumentPic: []
                                        },
                                        houseRuleLink: [
                                            {
                                                iLinkDays: "3",
                                                iLinkCount: "9"
                                            },
                                            {
                                                iLinkDays: "7",
                                                iLinkCount: "8"
                                            },
                                            {
                                                iLinkDays: "15",
                                                iLinkCount: "7"
                                            },
                                            {
                                                iLinkDays: "30",
                                                iLinkCount: "6"
                                            }
                                        ],
                                        houseRuleNight: [{dNightStart: "", iNightCount: ""}]
                                    };
                                    this.IsGo = true;
                                    this.$refs["my-upload"].clearFiles();
                                    // this.$emit("active", this.active);
                                    this.$router.push({
                                        name: "finish" //跳转的路径
                                    });
                                    return this.$message({
                                        type: "success",
                                        message: res.msg
                                    });
                                } else {
                                    return false;
                                }
                            });
                        } else {
                            return false;
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        next_Btn_other(fromOne, fromTow, fromThree) {
            this.$refs[fromOne].validate(valid => {
                if (valid) {
                    this.$refs[fromTow].validate(valid => {
                        if (valid) {
                            this.$refs[fromThree].validate(async valid => {
                                if (valid) {
                                    if (!this.checkeds) {
                                        return this.$message({
                                            type: "error",
                                            message: "是否认真阅读过房东规则、房源上线标准"
                                        });
                                    }

                                    if (!this.IsGo) return;
                                    this.IsGo = false;
                                    const {data: res} = await publishFiveAjax(this.from);
                                    if (res.code !== 200) {
                                        return this.$message({
                                            type: "error",
                                            message: res.msg
                                        });
                                    }
                                    // {
                                    //     houseId: this.houseId
                                    // }
                                    this.from = {
                                        checked: true,
                                        houseFavour: {
                                            mDepositMoney: "0",
                                            iSettingFestival: 0,
                                            mDailyPrice: "",
                                            mWeekEndPrice: "",
                                            mFestivePrice: "",
                                            iDepositRule: 0,
                                            iResidentNum: "",
                                            iCusPlusNum: "",
                                            iCusPlus: 1,
                                            mCusPlusMoney: "",
                                            mOtherMoney: "",
                                            iNewSale: 0,
                                            mNewCount: "8",
                                            iMiniDays: "",
                                            iMaxDays: "",
                                            iScheduledTime: "",
                                            iCheckStartTime: "",
                                            iCheckEndTime: "",
                                            iCheckOutTime: "",
                                            iCheckRule: 0,
                                            vDocumentType: 0,
                                            vDocumentPic: []
                                        },
                                        houseRuleLink: [
                                            {
                                                iLinkDays: "3",
                                                iLinkCount: "9"
                                            },
                                            {
                                                iLinkDays: "7",
                                                iLinkCount: "8"
                                            },
                                            {
                                                iLinkDays: "15",
                                                iLinkCount: "7"
                                            },
                                            {
                                                iLinkDays: "30",
                                                iLinkCount: "6"
                                            }
                                        ],
                                        houseRuleNight: [{dNightStart: "", iNightCount: ""}]
                                    };
                                    this.IsGo = true;
                                    this.$refs["my-upload"].clearFiles();
                                    // this.$emit("active", this.active);
                                    this.$router.push({
                                        name: "productDetails", //跳转的路径
                                        params: {
                                            houseId: this.houseId
                                        }
                                    });
                                    return this.$message({
                                        type: "success",
                                        message: res.msg
                                    });
                                } else {
                                    return false;
                                }
                            });
                        } else {
                            return false;
                        }
                    });
                } else {
                    return false;
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.information_title {
    height: 66px;
    line-height: 66px;
    margin-top: 30px;
    color: #f6b439;
    font-size: 20px;
    border-bottom: 1px solid #e1e1e1;
}

.form_box {
    padding: 30px 36px;
}

.radio_yes {
    width: 58px;
    line-height: 50px;
    float: left;
    // margin-left: 72px;
    margin-right: 100px;

    .radio_yes_left {
        margin: 12px 15px 0 0;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 1px solid #dcdcdc;
        float: left;
    }

    .radio_yes_right {
        float: left;
        font-size: 18px;
    }
}

.iDepositRule {
    height: 50px;
}

.iDepositRule_input {
    //width: 190px;
    height: 60px;
}

.radio_no {
    line-height: 40px;
    float: left;
    // margin-left: 100px;
    margin-right: 100px;

    .radio_no_left {
        margin: 12px 15px 0 0;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 1px solid #dcdcdc;
        float: left;
    }

    .radio_no_right {
        float: left;
        line-height: 45px;
        font-size: 18px;
    }
}

.radio_yes_left_s {
    margin: 12px 15px 0 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #f6b439;
    float: left;
}

.radio_no_left_s {
    margin: 12px 15px 0 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #f6b439;
    float: left;
}

.radio_box {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 6px;
    background-color: #f6b439;
}

.el-form-item {
    font-size: 18px;
    // margin-left: 36px;
    // margin-top: 24px;
    .el-select {
        width: 160px;
        height: 50px;
        margin: 0 15px;

        /deep/ .el-input__inner {
            font-size: 18px;
            height: 50px;
        }

        /deep/ .el-input {
            height: 50px;
        }
    }

    .el-input {
        width: 160px;
        height: 50px;

        margin-right: 10px;

        /deep/ .el-input__inner {
            height: 50px;
        }
    }

    .el-input:nth-child(4) {
        margin-right: 10px;
        margin-left: 50px;
    }

    .el-input:nth-child(6) {
        margin-left: 50px;
    }

    /deep/ .el-form-item__label {
        font-size: 18px;
        line-height: 50px;
        color: #000;
    }
}

/deep/ .el-form-item__content {
    font-size: 18px;
    line-height: 50px;
}

.radio_text {
    float: left;
    margin-left: -80px;
    line-height: 50px;
    color: #666666;
    font-size: 14px;
}

.input_text {
    margin-left: 12px;
    margin-right: 102px;
    line-height: 50px;
    color: #666666;
    font-size: 14px;
}

.form_item {
    overflow: hidden;
    height: 50px;

    .form_item_title {
        float: left;
        height: 40px;
        font-size: 14px;
        line-height: 40px;
        margin: 5px 142px 20px 0px;
        color: #666666;

        span {
            color: #f6b439;
        }
    }

    .form_item_title:nth-child(2) {
        margin-right: 170px;
    }
}

.form_item_s {
    height: 80px;

    .form_item_title_s {
        float: left;
        height: 80px;
        margin: 5px 190px 20px 20px;
        color: #666666;
    }
}

.form_item_title_s {
    float: left;
    height: 80px;
    margin: 5px 190px 20px 70px;
    color: #666666;
}

.input_title {
    width: 950px;
    height: 300px;

    /deep/ .el-textarea__inner {
        width: 958px;
        height: 300px;
    }
}

.radio {
    cursor: pointer;
    margin-bottom: 20px;
    width: 750px;
    height: 84px;
    border: 1px solid #e1e1e1;
    border-radius: 4px;

    .radio_left {
        float: left;
        margin: 30px 25px;
        border-radius: 50%;
        border: 1px solid #e1e1e1;
        width: 24px;
        height: 24px;
    }

    .radio_right {
        overflow: hidden;
        float: left;
        height: 69px;
        margin-top: 15px;
    }

    .radio_right_top {
        font-size: 18px;
        line-height: 24px;
    }

    .radio_right_bottom {
        height: 18px;
        margin-top: 12px;
        font-size: 14px;
        line-height: 18px;
        color: #666666;
    }
}

.radio:nth-child(1) {
    margin-top: 10px;
}

.radio_left_ {
    float: left;
    margin: 30px 25px;
    border-radius: 50%;
    border: 1px solid #f6b439;
    width: 24px;
    height: 24px;

    .ischeck {
        margin: 6px;
        height: 10px;
        width: 10px;
        border-radius: 50%;
        background-color: #f6b439;
    }
}

.select_box {
    height: 52px;
    margin-bottom: 20px;

    /deep/ .el-form-item {
        float: left;
    }
}

.none_margin {
    margin: 0px !important;
}

.qualification_bottom {
    border-bottom: 1px solid #e1e1e1;
    margin-bottom: 50px;
}

.qualification {
    overflow: hidden;
    vertical-align: middle;
    font-size: 18px;
    // margin-left: 34px;
    .qualification_left {
        height: 50px;
        float: left;
    }

    .qualification_right {
        height: 50px;
        float: left;

        span {
            color: #f6b439;

            img {
                width: 16px;
                height: 16px;
            }
        }
    }

    span {
        font-size: 18px;
        color: #f6b439;
    }

    img {
        vertical-align: middle;
        margin-left: 18px;
        width: 16px;
        height: 16px;
    }
}

.qualification_photograph {
    padding: 20px 0;
    overflow: hidden;
    vertical-align: middle;
    font-size: 18px;
    margin-left: 34px;
    // border-bottom: 1px solid #e1e1e1;
    // margin-bottom: 10px;
}

.qualification_title {
    margin-top: 10px;
    font-size: 16px;
    color: #333333;
    margin-bottom: 20px;
}

.checkbox_Box {
    width: 255px;
    height: 64px;
    float: left;
    cursor: pointer;
}

.qualification_checkbox_list {
    overflow: hidden;
    width: 1200px;
    font-size: 18px;
    margin-left: 34px;
}

.qualification_checkbox {
    float: left;

    width: 32px;
    height: 64px;

    .qualification_checkbox_false {
        float: left;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 1px solid #dcdcdc;
    }

    .qualification_checkbox_true {
        float: left;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 1px solid #f6b439;

        .checkbox_true {
            height: 10px;
            width: 10px;
            margin: 6px;
            background-color: #f6b439;
            border-radius: 50%;
        }
    }
}

.img_title {
    position: absolute;
    top: 24px;
    left: 30px;
    font-weight: bold;
    font-size: 20px;
    color: #000;
}

/deep/ .el-upload--picture-card {
    width: 120px;
    height: 120px;
    line-height: 120px;
}

.line {
    padding-left: 10px;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
    height: 120px;
    width: 120px;
    margin-right: 20px;
}

/deep/ .el-checkbox {
    margin-bottom: 40px;
    margin-right: 25px;
    height: 26px;

    .el-checkbox__inner {
        width: 24px;
        height: 24px;
    }

    .el-checkbox__inner::after {
        width: 8px;
        height: 14px;
        margin-left: 2px;
        color: #f6b439;
        border-right: 2px solid #f6b439;
        border-bottom: 2px solid #f6b439;
    }

    .el-checkbox__inner:hover {
        border-color: #f6b439;
    }

    .el-checkbox__label {
        font-size: 18px;
        color: #333333;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #fff;
        border-color: #999999;
    }
}

.next_Btn {
    height: 64px;
    margin-bottom: 100px;

    .affirm {
        width: 204px;
        height: 64px;

        font-size: 24px;
        color: #fff;
        background-color: #219653;
    }

    .preview {
        width: 204px;
        height: 64px;
        font-size: 24px;
        color: #fff;
        background-color: #f6b439;
        margin-left: 50px;
    }
}

.bedMessageOther {
    margin-top: 15px;
    float: left;
    width: 200px;
    height: 40px;
}

.bedMessage {
    position: relative;
    font-size: 18px;
    color: #000;

    .form_item {
        position: absolute;
        left: 130px;
        top: 0px;
        font-size: 14px;

        .form_item_title {
            height: 40px;
            margin: 5px 190px 20px 0px;
            color: #666666;
        }
    }
}

.acreage {
    margin-bottom: 20px;
    height: 50px;
    line-height: 50px;

    .el-select {
        margin: 0 20px 20px 0;
    }

    .el-select:nth-child(3) {
        margin: 0 10px 20px 0;
    }
}

.addDomain {
    margin-left: 30px;
    padding: 0px;
    width: 120px;
    height: 50px;
    font-size: 18px;
    color: #f6b439;
    border: 1px solid #f6b439;
}

.removeDomain {
    margin-left: 30px;
    padding: 0px;
    width: 120px;
    height: 50px;
    font-size: 18px;
    color: #eb5757;
    border: 1px solid #eb5757;
}

/deep/ .el-cascader {
    height: 50px;
    width: 160px;
}

/deep/ .el-cascader .el-input {
    height: 50px;
    width: 160px;
    margin-right: 20px;

    .el-input__inner {
        font-size: 18px;
        height: 50px;
    }
}

.iNightSale_text {
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    margin: 5px 142px 20px 0px;
    color: #666666;
}
</style>
